import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { profileApi } from "../api/endpoints";
import { tokenStore } from "../api/tokenStore";

const AuthContext = createContext(null);

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    const token = tokenStore.getAccess();
    if (!token) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const profile = await profileApi.me();
      setUser(profile);
      return profile;
    } catch {
      // Token invalid or expired, clear it
      tokenStore.clear();
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const login = () => {
    window.location.href = `${API_BASE}/login`;
  };

  const logout = () => {
    tokenStore.clear();
    setUser(null);
    window.location.href = `${API_BASE}/logout`;
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, isAuthenticated: !!user, login, logout, fetchUser, refresh: fetchUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
